import { PropsWithChildren } from 'react';

import { Typography, Box, Stack, tokens } from '@cast/design-system';

type Props = PropsWithChildren<{ title?: string; description: string }>;

export const SimulationContainer = ({
  title = 'Simulation',
  description,
  children,
}: Props) => {
  return (
    <Stack gap={8}>
      <Box>
        <Typography variant="h6">{title}</Typography>
        <Typography
          variant="P12R"
          sx={{ color: tokens.theme.fg.structural.secondary }}
        >
          {description}
        </Typography>
      </Box>
      <Stack
        gap={32}
        p={16}
        sx={{
          backgroundColor: tokens.theme.bg.structural.surfaceSubtle,
          borderColor: tokens.theme.border.structural.neutral,
          borderStyle: 'solid',
          borderWidth: 1,
        }}
        borderRadius={1}
      >
        {children}
      </Stack>
    </Stack>
  );
};
